const manageContacts = {
    manageContacts: {
        pageTitle: 'Manage Contacts',
        pageDescription: 'You can look up your satellite and communication schedules and schedule access to your satellite.',
        button: {
            search: 'Search',
            reset: 'Reset'
        }
    }
}

export default manageContacts;